import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";

const baseUrl = config.baseURL;
const PRIMARY_COLOR = "#2E4053";
const ACCENT_COLOR = "#8B4513";

const ShopRegister = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(""); // <-- added
  const [loading, setLoading] = useState(false);

  // --- Extract shop from subdomain ---
  const getShopFromSubdomain = () => {
    const host = window.location.hostname; // e.g., shop1.myplatform.com or localhost

    // Local development fallback
    if (host === "localhost" || host === "127.0.0.1") {
      return "test.spadeplatform.com"; // match your DB entry
    }

    // Production: extract subdomain
    const parts = host.split(".");
    if (parts.length >= 3) {
      return parts[0]; // first part is subdomain
    }

    return null; // fallback if subdomain cannot be determined
  };

  const shopSubdomain = getShopFromSubdomain();
  if (!shopSubdomain) {
    toast.error(
      "Cannot determine shop from URL. Please use your shop's subdomain."
    );
  }

  const handleRegister = async () => {
    if (!name || !email || !phone || !password || !confirmPassword) {
      toast.error("Please fill all fields.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    if (!shopSubdomain) return;
    console.log("Registering customer for shop:", shopSubdomain);
    setLoading(true);
    try {
      ///api/shop/customer/register?shop=test.spadeplatform.com
      const response = await fetch(`${baseUrl}/api/shop/customer/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, phone, password }),
      });

      const data = await response.json(); // parse JSON

      console.log("Registration response:", data);
      switch (data.messageId) {
        case 0:
          toast.success(data.message); // success
          localStorage.setItem("token", data.token); // save token
          navigate("/shop/customerlogin");
          break;
        case 1:
          toast.error("Cannot determine shop subdomain.");
          break;
        case 2:
          toast.error("Shop not found.");
          break;
        case 3:
          toast.error("Name, email, phone and password are required.");
          break;
        case 4:
          toast.error("Email already registered.");
          break;
        default:
          toast.error(data.message || "Registration failed.");
      }
    } catch (err) {
      console.error("Registration error:", err);
      switch (messageId) {
        case 0:
          displayMessage = `Success: ${message}`;
          toast.success(displayMessage);
          localStorage.setItem("token", res.data.token);
          navigate("/shop/customerlogin");
          break;
        case 1:
          displayMessage = "Cannot determine shop subdomain.";
          toast.error(displayMessage);
          break;
        case 2:
          displayMessage = "Shop not found.";
          toast.error(displayMessage);
          break;
        case 3:
          displayMessage = "Name, email, phone, and password are required.";
          toast.error(displayMessage);
          break;
        case 4:
          displayMessage = "Email already registered.";
          toast.error(displayMessage);
          break;
        default:
          displayMessage = error || "Registration failed.";
          toast.error(displayMessage);
          break;
      }
      toast.error(err.response?.data?.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F4F6F8",
        fontFamily: "Poppins, sans-serif",
        p: 2,
      }}
    >
      <ToastContainer position="top-right" autoClose={3000} />

      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 3, p: 2 }}>
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              mb: 3,
              color: PRIMARY_COLOR,
              textAlign: "center",
            }}
          >
            Register
          </Typography>

          <TextField
            fullWidth
            label="Full Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <TextField
            fullWidth
            label="Phone"
            variant="outlined"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <TextField
            fullWidth
            label="Confirm Password"
            variant="outlined"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{
              mb: 3,
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { borderColor: PRIMARY_COLOR },
              "& .MuiInputLabel-root.Mui-focused": { color: PRIMARY_COLOR },
            }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: PRIMARY_COLOR,
              color: "#fff",
              py: 1.5,
              fontWeight: 600,
              "&:hover": { backgroundColor: ACCENT_COLOR },
            }}
            onClick={handleRegister}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              "Register"
            )}
          </Button>

          <Typography
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: 14,
              color: "#555",
              cursor: "pointer",
            }}
            onClick={() => navigate("/shop/customerlogin")}
          >
            Already have an account? Login
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopRegister;
